/*
@PRODUCT_FEATURE: Q 1.0
*/
import View from './View';

export { default as View, getChromecastStartCastingStyles } from './View';

export default View;
